import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://copy.click';
const DEFAULT_OG = 'https://copy.click/og-image.png';

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

/**
 * SEO manager: sets title, meta, canonical, OG/Twitter tags and JSON-LD.
 */
export const Seo = ({ title, description, image = DEFAULT_OG, jsonLd, noindex = false }) => {
  const { pathname } = useLocation();
  const fullTitle = title ? `${title} | Copy.Click` : 'Copy.Click — Copy Elite Trading Signals from Telegram to MT5';
  const canonical = `${SITE_URL}${pathname}`;

  useEffect(() => {
    document.title = fullTitle;
    setMeta('name', 'description', description);
    setMeta('name', 'robots', noindex ? 'noindex,nofollow' : 'index,follow');
    setLink('canonical', canonical);

    setMeta('property', 'og:title', fullTitle);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', canonical);
    setMeta('property', 'og:image', image);
    setMeta('property', 'og:type', 'website');
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:site', '@copyclick');
    setMeta('name', 'twitter:title', fullTitle);
    setMeta('name', 'twitter:description', description);
    setMeta('name', 'twitter:image', image);

    const scriptId = 'jsonld-schema';
    let script = document.getElementById(scriptId);
    if (jsonLd) {
      if (!script) {
        script = document.createElement('script');
        script.type = 'application/ld+json';
        script.id = scriptId;
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }
    window.scrollTo(0, 0);
  }, [fullTitle, description, image, canonical, noindex, jsonLd]);

  return null;
};
